export type LocalServerAuthSource = {
  getAuthHeaders?: () => Record<string, string>;
};

export function localServerAuthHeaders(
  source: LocalServerAuthSource | undefined
): Record<string, string> {
  const headers = source?.getAuthHeaders?.() ?? {};
  const authorization = Object.entries(headers).find(
    ([name]) => name.toLowerCase() === 'authorization'
  );

  return authorization ? { [authorization[0]]: authorization[1] } : {};
}

export function localServerRequestOptions(source: LocalServerAuthSource | undefined): {
  headers: Record<string, string>;
} {
  return { headers: localServerAuthHeaders(source) };
}
